<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    goBack: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div class="row mt-3">
    <div class="col-12">
      <div
        class="page-title-box d-block d-md-flex align-items-center justify-content-between titulo-pagina"
      >
        <div class="d-flex gap-10">
          <v-tooltip top v-if="goBack">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class=""
                @click="$router.go(-1)"
                size="lg"
                v-bind="attrs"
                v-on="on"
              >
                mdi-arrow-left
              </v-icon>
            </template>
            <span>Volver</span>
          </v-tooltip>
          
          <h2 class="my-3 font-weight-bold" style="font-size: 28px !important">
            {{ title }}
          </h2>
        </div>

        <div class="page-title-right">
          <b-breadcrumb :items="items" class="m-0"></b-breadcrumb>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>

<style>
.btn.btn-primary {
  color: #fff !important;
}

.gap-10 {
  gap: 10px;
}

@media (max-width: 600px) {
  .titulo-pagina h4 {
    font-size: 0.8rem !important;
  }
  .breadcrumb-item {
    font-size: 0.7rem;
  }
}
</style>
